// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function paymobOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: 'meeza',
  };
}
